module.exports = __webpack_public_path__ + "img/user-help.b41eb853.webp";